"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "هل المبيدات المستخدمة آمنة على الأطفال والحيوانات الأليفة؟",
  answer: "نعم، في سرايا نستخدم مبيدات معتمدة من هيئة الغذاء والدواء، وهي آمنة تماماً على الصحة العامة والبيئة، حيث نطبق معايير السلامة العالمية في كافة عمليات الرش والمكافحة."
}, {
  question: "كم من الوقت تستغرق عملية مكافحة الحشرات في المنزل؟",
  answer: "تعتمد المدة على مساحة المكان ونوع الحشرة، ولكن في الغالب تستغرق العملية ما بين 45 إلى 90 دقيقة. فريقنا مدرب على إنجاز العمل بدقة وكفاءة عالية دون الحاجة لمغادرة المنزل في معظم الحالات."
}, {
  question: "هل تقدمون ضماناً على خدمات مكافحة النمل الأبيض؟",
  answer: "بالتأكيد، نقدم ضمانات تصل إلى 10 سنوات على خدمات رش الدفان ومكافحة النمل الأبيض، مع التزامنا التام بإعادة المعالجة مجاناً في حال ظهور أي إصابة خلال فترة الضمان."
}, {
  question: "كيف يمكنني الحصول على عرض سعر لخدمات رش المبيدات؟",
  answer: "يمكنك التواصل معنا مباشرة عبر الهاتف أو الواتساب، أو تعبئة نموذج طلب السعر في الموقع. سنقوم بتقدير التكلفة بناءً على نوع الخدمة المطلوبة ومساحة الموقع المراد معالجته."
}, {
  question: "هل تغطي خدماتكم كافة أحياء مدينة الرياض؟",
  answer: "نعم، نحن نغطي جميع أحياء الرياض (شمال، جنوب، شرق، وغرب) من خلال أسطول سيارات مجهز وفنيين متخصصين يصلون إليك في أسرع وقت ممكن لتقديم أفضل خدمة مكافحة."
}];
export default function FrequentlyAskedQuestions() {
  return <section data-section-id="224347" id="الأسئلة-الشائعة" className="bg-primary text-foreground px-4 sm:px-6 md:px-8 py-16 md:py-20 lg:py-32 relative overflow-hidden" dir="rtl">
      {}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,color-mix(in_srgb,var(--accent),transparent_95%)_0%,transparent_70%)] pointer-events-none" />
      
      <div className="mx-auto max-w-2xl md:max-w-4xl relative z-10">
        <div className="text-center mb-12 md:mb-20">
          <span className="inline-block px-4 py-1.5 mb-6 text-sm font-bold tracking-wider text-accent uppercase bg-accent/10 rounded-full border border-accent/20">
            مركز المساعدة
          </span>
          <h2 className="font-primary text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 text-[var(--text-light)]">
            الأسئلة الشائعة
          </h2>
          <div className="w-24 h-1 bg-accent mx-auto mb-8 rounded-full" />
          <p className="font-primary text-[var(--text-light)]/70 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
            إليك إجابات شاملة حول خدمات سرايا لمكافحة الحشرات ورش المبيدات بالرياض لضمان راحتك وسلامة منزلك.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-[var(--text-light)]/10 rounded-lg bg-secondary/40 backdrop-blur-md transition-all duration-300 shadow-lg hover:border-accent/30 data-[state=open]:border-accent/50 data-[state=open]:bg-secondary/60 overflow-hidden">
              <AccordionTrigger className="hover:no-underline px-4 sm:px-6 py-4 sm:py-6 text-right font-primary text-base sm:text-lg md:text-xl font-bold leading-snug text-[var(--text-light)] data-[state=open]:text-accent [&[data-state=open]>svg]:text-accent transition-colors">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-primary text-[var(--text-light)]/80 text-base sm:text-lg md:text-xl leading-relaxed px-4 sm:px-6 pb-8 pt-2 border-t border-[var(--text-light)]/5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}